(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TourSearch',
	};

	// Main form element
	var $form     = $('form#tour-search');
	var submitBtn = $form.find('.actions button');

	// Serialized form data
	var serial;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		serial = $form.serialize();
		getCount(serial, null);

		$form
			.on(
				'change',
				function change(e) {
					var id;

					// Do not run if checkbox is tour comparison
					if (e.target.className === 'tour-compare') { return; }

					// serialize form and call ajax with serialized data
					if (e.target.id !== 'toursearch-destination') {
						serial = $form.serialize();
						id     = e.target.id;
						getCount(serial, id);
					}
				}
			)
		;

		$("#toursearch-after").on("dp.change", function er(e) {
			var startDate = e.date,
			    endDate   = $('#toursearch-before').data('DateTimePicker');

			// if the start date is greater than the end date, add 30 days to the end
			if (endDate.date()) {
				if (endDate.date().isBefore(startDate) === true) {
					endDate.date(startDate.add(30, 'days'));
				}
			}

			$form.trigger('change');
		});

		$("#toursearch-before").on("dp.change", function er(e) {
			var startDate = $('#toursearch-after').data('DateTimePicker'),
			    endDate   = e.date;

			// if the end date is less than the start date, set them to be the same as the end date
			if (endDate) {
				if (endDate.isBefore(startDate.date()) === true) {
					startDate.date(endDate);
				}
			}

			$form.trigger('change');
		});

		$('.location-search')
			.on(
				'click',
				function clearlocation() {
					$(this).val('');
					$(this).siblings().val('');
				}
			)
		;

		Adzuki.Typeahead(
			'.location-search',
			'/TourSearch/locations',
			function select(item) {
				item.name = item.name += item.country;
				console.log(item);
				if (item.city_id) {
					$form.find('.city-id').val(item.city_id);
				}

				if (item.country_id) {
					$form.find('.country-id').val(item.country_id);
				}

				serial = $form.serialize();
				getCount(serial);
			},
			function template(item) {
				var html = '';

				html += item.name;

				return html;
			}
		);
	};

	function getCount(serial, id) {
		setCount();
		Adzuki.Ajax
			.post(
				Adzuki.base_uri + '/TourSearch/countResults',
				{
					form_data: serial,
				}
			).then(
				function success(data) {
					setCount(data.matched);
					if (id !== 'toursearch-supplier' && id !== null) {
						setSuppliers(data.suppliers);
					}
				}
			)
		;
	}

	function setCount(count) {
		var panel = $('.bottom-panel');
		if (count) {
			panel.addClass('show');
			panel.find('.bottom-panel-result-count').text(count);
			if (parseInt(count) === 0) {
				console.log(count);
				submitBtn.attr('disabled', 'true');
			} else {
				submitBtn.removeAttr('disabled');
			}
		} else {
			panel.find('.bottom-panel-result-count').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-pulse fa-fw"></i>');
		}
	}

	function setSuppliers(suppliers) {

		var supplierSelect = $('#toursearch-supplier');
		var currentVal     = supplierSelect.val();

		if (suppliers.length === 0) {
			supplierSelect.attr('disabled', 'disabled');
			supplierSelect.val('');
		} else {
			supplierSelect.removeAttr('disabled');
			supplierSelect.empty();
			supplierSelect.append($('<option>').text('Select Supplier').attr('value', ''));

			$.each(
					suppliers,
					function setSupplierOptions(i, supplier) {
						supplierSelect.append($('<option>').text(supplier.name).attr('value', supplier.id));
					}
				)
			;

			supplierSelect.val(currentVal);
		}
	}

}(jQuery, window.Adzuki || {}));
